import React from "react";
import "./styles.css";

const Spinner = props => {
  return (
    <div className="spinnerContainer pRel">
      <svg
        className="spinner"
        viewBox="0 0 66 66"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          className="path"
          fill="none"
          strokeLinecap="round"
          cx="33"
          cy="33"
          r="30"
        />
      </svg>
    </div>
  );
};

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/Spinner/index.js